import z from "zod";

import {
  AccountSchema,
  ActivationStatusSchema,
  ActivationTypeSchema,
  OrgSchema,
  UserSchema
} from "../../models/generated";

// AccountType: derived from User profile presence (not stored in Prisma)
export enum AccountType {
  AGENT = "AGENT",
  CANDIDATE = "CANDIDATE",
  ORG_MEMBER = "ORG_MEMBER"
}
export const AccountTypeSchema = z.nativeEnum(AccountType);

export { ActivationStatusSchema };
export { ActivationTypeSchema };

export const AccountDetailSchema = AccountSchema.extend({
  user: UserSchema.nullable(),
  org: OrgSchema.nullable()
});
export type AccountDetail = z.infer<typeof AccountDetailSchema>;

// Registration request
export const RegisterAccountSchema = z.object({
  name: z.string().min(1),
  email: z.string().email(),
  phone: z.string().optional().nullable(),
  gender: z.string().optional(),
  dateOfBirth: z.string().optional().nullable(),
  referrerCode: z.string().optional(),
  accountType: AccountTypeSchema.default(AccountType.CANDIDATE)
});
export type RegisterAccount = z.infer<typeof RegisterAccountSchema>;

// Activation status detail (returned by GET /account/activation)
export const ActivationDetailSchema = z.object({
  accountType: AccountTypeSchema,
  activationStatus: ActivationStatusSchema,
  activation: z
    .object({
      type: ActivationTypeSchema,
      amount: z.number(),
      paidAt: z.coerce.date().nullable(),
      status: ActivationStatusSchema
    })
    .nullable()
});
export type ActivationDetail = z.infer<typeof ActivationDetailSchema>;

export const SetReferralSchema = z.object({
  code: z.string()
});
export type SetReferral = z.infer<typeof SetReferralSchema>;
